import React, { useState } from 'react';
import './FAQ.css';

const FAQ = ({ faqData, title = 'FAQs' }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="snow-faq" id="faq">
      <div className="snow-faq-inner">
        <div className="snow-section-header">
          <span className="snow-section-label">❆ Common Questions</span>
          <h2 className="snow-section-title">{title}</h2>
        </div>

        <div className="snow-faq-list">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`snow-faq-item ${openIndex === index ? 'open' : ''}`}
            >
              <button
                className="snow-faq-question"
                onClick={() => toggle(index)}
                aria-expanded={openIndex === index}
              >
                <span className="snow-faq-q-number">Q{index + 1}</span>
                <span className="snow-faq-q-text">{item.question}</span>
                <span className="snow-faq-toggle">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d={openIndex === index ? 'M4 8H12' : 'M8 4V12M4 8H12'}
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
              </button>
              <div className="snow-faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
